const careerBt = {
  breadcrumbs: { home: 'གཙོ་ངོས།', career: 'ལས་འགན།' },
  hero: {
    title: 'ཁྱེད་ཀྱི་རྒྱལ་སྤྱིའི་ལས་འགན་འགོ་འཛུགས།',
    subtitle: 'Grameen Bazar དང་མཉམ་དུ་འབྲེལ་མཐུད་བྱས་ཏེ་ རྒྱལ་ཁབ་འབྲུག་གི་གྲོང་སྡེའི་ཚོང་འབྲེལ་དེ་ཌི་ཇི་ཊཱལ་ལུ་བསྒྱུར་བཅོས་བྱོས།'
  },
  companyStats: [
    { value: '500+', label: 'ལས་བྱེད་པ།' },
    { value: '10+', label: 'གནས་ཁང་།' },
    { value: '98%', label: 'ལས་བྱེད་པའི་དགའ་སྟོན།' },
    { value: '100+', label: 'སློབ་སྦྱོང་ལས་འགན།' }
  ],
  jobsSection: { title: 'ལས་འགན་གསར་པ།', subtitle: 'ངོང་བཅས་དང་མཉམ་དུ་ལས་ཀ་བྱས་ནས་ཁྱེད་ཀྱི་ལས་འགན་ལེགས་སྒྲུབ་བྱོས།' },
  labels: {
    featured: 'དམིགས་བསལ།',
    postedSuffix: 'གསལ་བསྒྲགས།',
    salary: 'གླ་ཆ།',
    deadline: 'ཞུ་འབུལ་ཚེས་མཇུག'
  },
  buttons: {
    viewDetails: 'རྒྱས་བཤད་བལྟ།',
    apply: 'ཞུ་འབུལ།',
    cancel: 'ཆ་མེད།',
    submit: 'ཞུ་འབུལ་གཏང་།',
    contact: 'འབྲེལ་བྱ།'
  },
  cta: {
    title: 'ཁྱེད་ལ་འོས‌་པའི་ལས་འགན་མ་ཐོབ་མིན་?',
    subtitle: 'ངས་འབྲེལ་བྱོས། ངས་ལས་འགན་གསར་པ་ཐོབ་ཚེ་ཁྱེད་ལ་བརྡ་བསྐུལ་བྱོས།',
    contact: 'འབྲེལ་བྱ།'
  },
  form: {
    titleSuffix: ' - ཞུ་འབུལ་གཞིས་ཁྲོད།',
    name: 'མིང་།',
    email: 'གློག་འཕྲིན།',
    phone: 'ཁ་ལན།',
    education: 'ཤེས་ཡོན།',
    experience: 'ལས་སྒོའི་ཉམས་མྱོང་།',
    uploadResume: 'ལས་བརྡ་འགོད་པ་སྤྲོད། (PDF, DOC, DOCX)'
  },
  snackbar: { success: 'ཁྱེད་ཀྱི་ཞུ་འབུལ་གཏང་ཡོད། ངས་མགྱོགས་པོར་འབྲེལ་བྱོས།' }
};

export default careerBt;


